module.exports = {
    RESOURCE_GROUP_ID: '7e77a921-566c-4c31-a344-571a0b4e15c3',
    RESOURCE_GROUP_NAME: 'GRP_EAD_APP_TRAZABILIDAD'
}